import {
  getMetafieldDateTime,
  getMetafieldDimension,
  getMetafieldNumber,
  getMetafieldString,
  getMetafieldVolume,
  getMetafieldWeight,
} from '@shared/shop-api/metafield/mapper'
import type { MetafieldFragment } from '@shared/types/storefront/graphql'

export const toVariantAttributes = (
  metafields: (MetafieldFragment | null)[]
) => {
  return {
    specialPriceTo: getMetafieldDateTime(metafields, 'special_price_to'),
    specialPriceFrom: getMetafieldDateTime(metafields, 'special_price_from'),
    specialPrice: getMetafieldNumber(metafields, 'special_price'),
    shoeSizeWidth: getMetafieldString(metafields, 'shoe_size_width'),
    bestPriceTimestamp: getMetafieldDateTime(
      metafields,
      'best_price_timestamp'
    ),
    bestPrice: getMetafieldNumber(metafields, 'best_price'),
    depth: getMetafieldDimension(metafields, 'depth'),
    height: getMetafieldDimension(metafields, 'height'),
    width: getMetafieldDimension(metafields, 'width'),
    weight: getMetafieldWeight(metafields, 'weight'),
    volume: getMetafieldVolume(metafields, 'volume'),
    launchDate: getMetafieldDateTime(metafields, 'launch_date'),
    restockDate: getMetafieldDateTime(metafields, 'restock_date'),
  }
}
